import * as React from "react"
import PopupTutorial from "../components/com_popup-tutorial"
import addButtonImage from "../../core/assets/tuto_add_button.png"
import changeLanguage from "../../core/assets/tuto_change_language.png"
import bruneauIlusImg from "../../core/assets/bruneau_illus.jpg"
import { Grid, Segment, Rail, Image, Message } from "semantic-ui-react"
import { ISupplierInfo } from "../../models"

interface IHomeProps {
  supplierParameters: {
    supplierName: string
    nbProducts: 0
    nbActiveProducts: 0
    nbInactiveProducts: 0
    nbNotValidProducts: 0
  }
  translations: any
  fetchSupplierParameters: () => void
}

class Home extends React.Component<IHomeProps, any> {
  public componentDidMount() {
    this.props.fetchSupplierParameters()
  }

  public render() {
    const {
      supplierName = "N/A",
      nbProducts = 0,
      nbActiveProducts = 0,
      nbInactiveProducts = 0,
      nbNotValidProducts = 0,
    } = this.props.supplierParameters

    const { translations } = this.props

    return (
      <div className="home">
        <Grid centered={true} columns={3} className="welcome-grid">
          <Grid.Column>
            <Segment>
              {/* Center Content ------------------------------------------*/}
              <Segment textAlign="center" className="home-main-content">
                <h1 className="page-title"> {translations.welcome} </h1>
                <br />
                <br />
                <p> {translations.shortPresentation} </p>
                <p className="paragraph"> {translations.longPresentation} </p>
                <Message info={true}>
                  <Message.Header>{translations.lostHeader}</Message.Header>
                  <p>{translations.lostContent}</p>
                </Message>
                <br />
                <Image
                  className="home-picture"
                  size="medium"
                  src={bruneauIlusImg}
                />
                <br />
                <br />
                <p className="paragraph"> {translations.contact} </p>
              </Segment>
              {/* Left Rail ---------------------------------------------- */}
              <Rail dividing={true} position="left">
                <Segment
                  size="huge"
                  color="red"
                  textAlign="center"
                  vertical={true}
                >
                  {translations.paramsSectionHeader}
                </Segment>
                <Segment textAlign="left" vertical={true}>
                  {translations.paramsNameSupplierLabel + " : " + supplierName}
                </Segment>
                <Segment textAlign="left" vertical={true}>
                  {translations.paramsProductNumberLabel + " : " + nbProducts}
                </Segment>
                <Segment textAlign="left" vertical={true}>
                  {translations.paramsActiveProductNumberLabel +
                    " : " +
                    nbActiveProducts}
                </Segment>
                <Segment textAlign="left" vertical={true}>
                  {translations.paramsDeactivatedProductNumberLabel +
                    " : " +
                    nbInactiveProducts}
                </Segment>
                <Segment textAlign="left" vertical={true}>
                  {translations.paramsNotValidateProductNumberLabel +
                    " : " +
                    nbNotValidProducts}
                </Segment>
              </Rail>
              {/* Right Rail ---------------------------------------------- */}
              <Rail dividing={true} position="right">
                <Segment
                  size="huge"
                  color="red"
                  textAlign="center"
                  vertical={true}
                >
                  {translations.tutorialSectionHeader}
                </Segment>
                <PopupTutorial
                  name={translations.tutorialAddProductLabel}
                  icon="question"
                  image={addButtonImage}
                  position="bottom center"
                />
                <PopupTutorial
                  name={translations.tutorialChangeLanguageLabel}
                  icon="question"
                  image={changeLanguage}
                />
              </Rail>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

export default Home
